import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import PayerMatrixPagination from './PayerMatrixPagination';

const StatesTab = ({ searchTerm = "" }) => {
    const navigate = useNavigate();
    const [states, setStates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    useEffect(() => {
        const fetchStates = async () => {
            try {
                setLoading(true);
                const response = await axios.get(
                    `${process.env.REACT_APP_BASE_URL}/states/all`
                );
                if (response.data.success) {
                    const sortedData = response.data.data.sort((a, b) =>
                        (a.name || "").localeCompare(b.name || "")
                    );
                    setStates(sortedData);
                } else {
                    toast.error(response.data.message || "Failed to fetch states");
                }
            } catch (error) {
                console.error("Error fetching states:", error);
                toast.error(error?.response?.data?.message || "Error connecting to server");
            } finally {
                setLoading(false);
            }
        };

        fetchStates();
    }, []);

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
    };

    const thStyle = {
        backgroundColor: '#064260',
        color: '#FFFFFF',
        padding: '14px 16px',
        textAlign: 'left',
        fontSize: '11px',
        fontWeight: '600',
        letterSpacing: '0.6px',
        textTransform: 'uppercase',
        fontFamily: 'Poppins, sans-serif',
        borderRadius: 0,
    };

    const tdStyle = {
        padding: '15px',
        borderBottom: '1px solid #F0F0F0',
        fontSize: '14px',
        color: '#333333',
    };

    const filteredStates = states.filter((state) => {
        const id = (state.state_id || state._id || "").toString().toLowerCase();
        const name = (state.name || "").toLowerCase();
        const search = searchTerm.toLowerCase();
        return id.includes(search) || name.includes(search);
    });

    const indexOfLastItem = currentPage * rowsPerPage;
    const indexOfFirstItem = indexOfLastItem - rowsPerPage;
    const currentItems = filteredStates.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <div style={{ width: '100%', overflowX: 'auto' }}>
            {loading ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>Loading states...</div>
            ) : filteredStates.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>No states found.</div>
            ) : (
                <>
                    <table className="admin-table mb-0" style={tableStyle}>
                        <thead>
                            <tr>
                                <th style={{ ...thStyle }}>ID</th>
                                <th style={thStyle}>State</th>
                                <th style={thStyle}>Insurances</th>
                                <th style={{ ...thStyle, textAlign: 'center' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((row, index) => (
                                <tr key={index}>
                                    <td style={tdStyle}>{row.state_id || row._id}</td>
                                    <td style={tdStyle}>{row.name}</td>
                                    <td style={tdStyle}>{row.insurances || 0}</td>
                                    <td style={{ ...tdStyle, textAlign: 'center' }}>
                                        <button
                                            className="app-view-btn"
                                            onClick={() => navigate(`/payer-matrix/state/${row._id}/insurances`, { state: { stateName: row.name } })}
                                        >
                                            View
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <PayerMatrixPagination
                        totalItems={filteredStates.length}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                    />
                </>
            )}
        </div>
    );
};

export default StatesTab;
